module.exports = __webpack_public_path__ + "static/img/page4-bg.e3872e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page4-bg.png
// module id = c3hy
// module chunks = 215